import { useAuth } from '@shared/auth';
import { Flex, Loading } from '@shared/components';
import { usePermission } from '@shared/permissions';
import { Sidebar } from '@user-management/app-frame';
import { Outlet } from 'react-router-dom';

import { ProtectedRoute } from '../containers';

export default function App() {
  const { profileLoading: isProfileLoading } = useAuth();
  const { loading: isLoadingPermission } = usePermission();

  if (isProfileLoading || isLoadingPermission) {
    return <Loading sx={{ height: '100dvh' }} />;
  }

  return (
    <ProtectedRoute>
      <Flex sx={{ width: '100%', height: '100dvh' }}>
        <Sidebar />
        <Flex
          sx={{
            width: '100%',
            overflow: 'auto',
            flexDirection: 'column',
            position: 'relative',
          }}
        >
          <Outlet />
        </Flex>
      </Flex>
    </ProtectedRoute>
  );
}
